"use strict";

exports.__esModule = true;
var _PredefinedCommentsScreen = require("./PredefinedCommentsScreen.js");
Object.keys(_PredefinedCommentsScreen).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PredefinedCommentsScreen[key]) return;
  exports[key] = _PredefinedCommentsScreen[key];
});